const colors = {
    base: {
        white: "#FFFFFF",
        gray: "#BFBFCC",
        tertiary: "#EAEAEA",
        black: "#000000",
        transparent: "rgba(255, 255, 255, 0)",
    },
    gray: {
        25: "#FDFDFD",
        50: "#FAFAFA",
        100: "#F5F5F5",
        200: "#E9EAEB",
        300: "#D5D7DA",
        400: "#A4A7AE",
        500: "#717680",
        600: "#535862",
        700: "#414651",
        800: "#252B37",
        900: "#1B1D27",
        950: "#0A0D12",
    },
    text: {
        900: "#1B1D27",
    },
    brand: {
        25: "#FEFEFE",
        50: "#FAFAFA",
        100: "#D1C7FF",
        200: "#A87EFF",
        300: "#01ECFF",
        400: "#00B2D6",
        500: "#962EFF",
        600: "#211F45",
        700: "#021C64",
        800: "#030039",
        900: "#02002B",
        950: "#01001A",
    },
    error: {
        25: "#FFFBFA",
        50: "#FEF3F2",
        100: "#FEE4E2",
        200: "#FECDCA",
        300: "#FDA29B",
        400: "#F97066",
        500: "#F04438",
        600: "#D92D20",
        700: "#B42318",
        800: "#912018",
        900: "#7A271A",
        950: "#55160C",
    },
    warning: {
        25: "#FFFCF5",
        50: "#FFFAEB",
        100: "#FEF0C7",
        200: "#FEDF89",
        300: "#FEC84B",
        400: "#FDB022",
        500: "#F79009",
        600: "#DC6803",
        700: "#B54708",
        800: "#93370D",
        900: "#7A2E0E",
        950: "#4E1D09",
    },
    success: {
        25: "#F6FEF9",
        50: "#ECFDF3",
        100: "#DCFAE6",
        200: "#ABECF6",
        300: "#75E0A7",
        400: "#47CD89",
        500: "#17B26A",
        600: "#079455",
        700: "#067647",
        800: "#085D3A",
        900: "#074D31",
        950: "#053321",
    },
};

export default colors;